var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 52,
    viewBox: "0 0 62 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.5 1H3.5C2.11929 1 1 2.11929 1 3.5V48.5C1 49.8807 2.11929 51 3.5 51H58.5C59.8807 51 61 49.8807 61 48.5V3.5C61 2.11929 59.8807 1 58.5 1Z",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 38.4997L16.7188 22.781C16.9514 22.5448 17.2287 22.3572 17.5345 22.2291C17.8403 22.1011 18.1685 22.0352 18.5 22.0352C18.8315 22.0352 19.1597 22.1011 19.4655 22.2291C19.7713 22.3572 20.0486 22.5448 20.2812 22.781L34.2188 36.7185C34.4514 36.9547 34.7287 37.1423 35.0345 37.2703C35.3403 37.3984 35.6685 37.4643 36 37.4643C36.3315 37.4643 36.6597 37.3984 36.9655 37.2703C37.2713 37.1423 37.5486 36.9547 37.7812 36.7185L44.2188 30.281C44.4514 30.0448 44.7287 29.8572 45.0345 29.7291C45.3403 29.6011 45.6685 29.5352 46 29.5352C46.3315 29.5352 46.6597 29.6011 46.9655 29.7291C47.2713 29.8572 47.5486 30.0448 47.7812 30.281L61 43.4997",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.75 21C41.8211 21 43.5 19.3211 43.5 17.25C43.5 15.1789 41.8211 13.5 39.75 13.5C37.6789 13.5 36 15.1789 36 17.25C36 19.3211 37.6789 21 39.75 21Z",
    fill: "#333333"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.db28231fa3e35363dfd51872d1d86e7e.svg";
export { ForwardRef as ReactComponent };